<script setup>
import axios from 'axios'
import { reactive, ref } from 'vue'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

const props = defineProps({
  dayId: {
    type: Number,
    default: null,
    required: false
  }
})
const dialogWork = reactive({
  createdAt: null,
  id: null,
  history: [],
  date: ''
})
const displayModal = ref(false)
const openHistoryModal = async (workId) => {
  const result = await axios.get(`/works/${workId}.json`)
  dialogWork.createdAt = result.data.created_at
  dialogWork.id = result.data.id
  dialogWork.history = result.data.history
  dialogWork.date = result.data.date

  displayModal.value = true
}
const closeHistoryModal = () => {
  displayModal.value = false
}
</script>

<template>
  <Button
    icon="pi pi-history"
    class="p-button-rounded p-button-secondary p-button-outlined p-button-history"
    :disabled="props.dayId == null"
    @click="openHistoryModal(props.dayId)"
  />
  <Dialog
    v-model:visible="displayModal"
    :header="`${dialogWork.date} 履歴`"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '50vw' }"
    :modal="true"
    :maximizable="true"
  >
    <DataTable
      :value="dialogWork.history"
      :scrollable="true"
      :maximizable="true"
      scroll-height="flex"
    >
      <Column field="time" header="更新日時" style="min-width: 200px"></Column>
      <Column field="user" header="更新者" style="min-width: 200px"></Column>
      <Column field="detail" header="更新内容" style="min-width: 200px">
        <template #body="slotProps">
          <div class="flex flex-col">
            <div v-for="items in slotProps.data.detail" :key="items">
              <div
                v-for="(value, key, index) in items"
                :key="index"
                class="my-1"
              >
                <span
                  class="inline-flex items-center rounded-full bg-gray-100 px-3 py-0.5 text-sm font-medium text-gray-800"
                >
                  {{ key }}
                </span>
                {{ value }}
              </div>
            </div>
          </div>
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <Button
        label="閉じる"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeHistoryModal"
      />
    </template>
  </Dialog>
</template>

<style lang="scss" scoped>
:deep(.p-button-history.p-button.p-button-icon-only.p-button-rounded) {
  height: 1.5rem;
  width: 1.5rem;
}
</style>
